export const isMobileDevice = (): boolean => {
  const { userAgent } = navigator;
  const AgentUserOs = userAgent.replace(/ /g, '');
  return !!(AgentUserOs.indexOf('Android') !== -1 || navigator.userAgent.match(/iPhone/i));
};

export const isMobileScreen = (): boolean => {
  const { innerWidth } = window;
  return innerWidth <= 768;
};

export const isMobile = (): boolean => isMobileDevice() || isMobileScreen();

export const getManual = () => {
  const a = document.createElement('a');
  a.href = 'https://sikd.ae/manual-store';
  a.download = '식당대장-사용설명서.pdf';
  a.target = '_blank';
  document.body.appendChild(a);
  a.click();
  a.remove();
};
